// opervex-frontend/src/routes/serviceManagementRoutes.js

import ServiceOrder from "../pages/ServiceManagement/ServiceOrder";
import Service from "../pages/ServiceManagement/Service";

const registerRoutes = [
  // Service Order
  { path: "ServiceManagement/ServiceOrder", private: true, component: <ServiceOrder />, role: "ORDER_SERVICE" },
  { path: "ServiceManagement/ServiceOrder/:id", private: true, component: <ServiceOrder />, role: "ORDER_SERVICE" },

  // Service
  { path: "ServiceManagement/Service", private: true, component: <Service />, role: "SERVICES" },
  { path: "ServiceManagement/Service/:id", private: true, component: <Service />, role: "SERVICES" },
];

export default registerRoutes;
